<template>
  <v-dialog
    :value="open"
    persistent
    max-width="250"
    content-class="request-field-item-dialog"
  >
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        v-if="editedItem !== null"
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0; overflow: visible"
      >
        <input-field
          :label="$tc('Field', 1)"
          :value="editedItem.artf_request_form_field_id"
          input-type="other"
          size="100"
          :required="true"
          :field-disabled="editing"
        >
          <treeselect
            :value="editedItem.artf_request_form_field_id"
            @input="updateValue"
            :options="fieldOptions"
            :load-options="loadFieldOptions"
            :auto-load-root-options="true"
            :disabled="editing"
          />
        </input-field>

        <input-field
          :label="$t('DefaultValue')"
          v-model="editedItem.artf_default_value"
          :input-type="inputType"
          min="0"
          onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
          size="100"
          :required="true"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="close"
        />
        <management-button
          type="execute"
          :label="editing ? $t('ApplyChanges') : $t('Create')"
          :disabled="!requiredAreFilled"
          @buttonClick="applyChanges"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import _ from "lodash";
import { mapActions } from "vuex";
import ManagementButton from "@/components/Management/ManagementButton";

export default {
  name: "ReservationTemplateFieldForm",

  components: { ManagementButton, InputField },

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    },

    /**
     * Position of the field in the list, if the user is editing
     */
    itemIndex: {
      type: Number
    },

    /**
     * Fields to be edited
     */
    originalItem: {
      type: Object,
      required: true
    },

    /**
     * fields that have already been selected
     */
    selectedFields: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      /**
       * Data that was changed while editing the field
       */
      editedItem: {},

      fieldOptions: null,

      inputType: "text"
    };
  },

  computed: {
    requiredAreFilled() {
      return (
        this.editedItem.artf_request_form_field_id &&
        this.editedItem.artf_default_value
      );
    },

    editing() {
      return this.itemIndex > -1;
    }
  },

  watch: {
    originalItem() {
      this.setItemToEdit();
    }
  },

  mounted() {
    this.setItemToEdit();
  },

  methods: {
    ...mapActions(["fetchFormFields"]),

    setItemToEdit() {
      this.fieldOptions = null;
      if (this.editing) {
        this.editedItem = _.cloneDeep(this.originalItem);
      } else {
        this.editedItem = {
          artf_request_form_field_id: null,
          artf_default_value: null
        };
      }
    },

    async loadFieldOptions({ callback }) {
      try {
        const filteredOptions = [];
        let fields = await this.fetchFormFields([
          { field: "tab.uuid", value: "605e1de9-bd01-4b00-b32a-19874419b2e3" }
        ]);
        const options = this.editing
          ? fields
          : this.getFieldOptionsInCreateMode(fields);
        options.forEach(option =>{
          if(!(option.label === "Internal Reference")){
            filteredOptions.push(option);
          }
        })
        this.fieldOptions = filteredOptions;
      } catch (e) {
        console.log(e);
      } finally {
        callback();
      }
    },

    getFieldOptionsInCreateMode(fields) {
      let fieldOptions = [];
      fields.forEach(field => {
        let hasSelectedField = this.selectedFields.find(
          fieldSelected =>
            fieldSelected.request_form_field.var_name === field.var_name
        );
        if (
          !hasSelectedField &&
          !field.disable &&
          !field.hide &&
          field.input_type !== "" &&
          field.input_type !== "other" &&
          field.input_type !== "date" &&
          field.input_type !== "datetime" &&
          field.input_type !== "group" &&
          field.input_type !== "checkbox" &&
          field.input_type !== "radio" &&
          field.var_name !== "ar_comment" &&
          field.var_name !== "ar_external_id"
        ) {
          fieldOptions.push(field);
        }
      });
      return fieldOptions;
    },

    applyChanges() {
      if (this.requiredAreFilled) {
        if (this.editing) {
          this.$emit("edit", this.editedItem);
        } else {
          this.editedItem.request_form_field = this.fieldOptions.find(
            item => item.id === this.editedItem.artf_request_form_field_id
          );
          this.$emit("add", this.editedItem);
        }
        this.fieldOptions = null;
      }
    },

    close() {
      this.$emit("close");
      this.fieldOptions = null;
    },

    updateValue(value) {
      if (value) {
        let field = this.fieldOptions.find(item => item.id === value);
        this.inputType = field.input_type;
      }
      this.editedItem.artf_default_value = null;
      this.editedItem.artf_request_form_field_id = value;
    }
  }
};
</script>

<style>
.request-field-item-dialog {
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Templates/ReservationTemplateFieldForm.vue